var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleArrowsUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 29,
    viewBox: "0 0 30 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3987_12782",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 30,
    height: 29
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    transform: "matrix(0.707107 0.707107 0.707107 -0.707107 0.859375 14.1406)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3987_12782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0615 5.30179L10.0511 11.3122L11.1117 12.3729L16.0615 7.42311L21.0112 12.3729L22.0719 11.3122L16.0615 5.30179ZM16.0615 10.9586L10.0511 16.9691L11.1117 18.0297L16.0615 13.08L21.0112 18.0297L22.0719 16.9691L16.0615 10.9586Z",
    fill: "#FF6B00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrowsUp);
export default __webpack_public_path__ + "static/media/double_arrows_up.2f3be6468872c963dcf087f471754370.svg";
export { ForwardRef as ReactComponent };